import ExceptionPage from "../../components/exception-page/ExceptionPage";

function NF401() {

    return (
        <ExceptionPage title={'401'} subTitle={'Role Access Error'} description={"You don't have required role access for TecTool.\n Please contact your manager for access."}/>
    );
}

export default NF401;